import { Icon } from "@circle-react/components/shared/Icon";
import { Tippy } from "@circle-react/components/shared/Tippy";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

export interface CheckoutPreviewEntryProps {
  className?: string;
  dataTestId?: string;
  hide?: boolean;
  label: string | React.ReactNode;
  labelClassName?: string;
  labelColor?: string;
  labelSize?: "xs" | "sm" | "md";
  labelWeight?: "normal" | "medium" | "semibold";
  tooltip?: string;
  value?: string;
  valueColor?: "text-green-600" | "text-primary";
  valueSize?: "sm" | "md" | "lg";
  valueWeight?: "normal" | "medium" | "semibold";
}

const labelTypes = {
  xs: Typography.LabelXs,
  sm: Typography.LabelSm,
  md: Typography.LabelMd,
  default: Typography.LabelMd,
};

export const PreviewEntry = ({
  className,
  label,
  labelSize = "sm",
  labelWeight = "normal",
  labelColor,
  labelClassName = "",
  tooltip,
  value,
  valueSize = "sm",
  valueColor = "text-primary",
  valueWeight = "normal",
  hide = false,
  dataTestId,
}: CheckoutPreviewEntryProps) => {
  if (hide) {
    return null;
  }

  const Label = labelTypes[labelSize] || labelTypes["default"];
  const Value =
    valueSize === "sm"
      ? Typography.LabelSm
      : valueSize === "md"
        ? Typography.LabelMd
        : Typography.LabelLg;

  return (
    <div
      className={classNames(
        className,
        "flex flex-row items-center justify-between space-x-2 whitespace-nowrap md:space-x-3",
      )}
      data-testid={dataTestId}
    >
      <div className="flex flex-row gap-x-2 whitespace-normal">
        <Label weight={labelWeight} color={labelColor}>
          <span className={labelClassName}>{label}</span>
        </Label>
        {tooltip && (
          <Tippy
            dataTestId="checkout-form-preview-entry-tooltip"
            className="inline-flex"
            content={tooltip}
          >
            <Icon type="16-question-mark" size={16} color="text-primary" />
          </Tippy>
        )}
      </div>
      {value && (
        <Value weight={valueWeight} color={valueColor}>
          {value}
        </Value>
      )}
    </div>
  );
};
